import React, { Component } from "react";

import { connect } from "react-redux";

import ViewHeader from "./view-header";
import ViewContent from "./view-content";

import "./style.css";

class ManifestUpload extends Component {
    render() {
        return (
            <div className="view">
                <ViewHeader />
                <ViewContent />
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    const { authentication } = state;
    const { user } = authentication;
    return user;
}

export default connect(mapStateToProps)(ManifestUpload);



// WEBPACK FOOTER //
// ./src/views/uploadManifest/index.js